import { ArrayType } from './array.js';
import { isType } from './types.js';
export function parseFieldConfig(init) {
    if (isType(init))
        return { type: init };
    if (init instanceof FieldBuilder)
        return init.toInit();
    return init;
}
export class FieldBuilder {
    type;
    init;
    constructor(type, init) {
        this.type = type;
        this.init = init;
        const _toArray = ((length) => {
            return new FieldBuilder(new ArrayType(type, length), init);
        });
        Object.setPrototypeOf(_toArray, new.target.prototype);
        Object.assign(_toArray, { type, init });
        return _toArray;
    }
    /**
     * Align the field to a given byte boundary.
     */
    align(align) {
        return new FieldBuilder(this.type, { ...this.init, align });
    }
    countedBy(countedBy) {
        return new FieldBuilder(this.type, { ...this.init, countedBy });
    }
    /**
     * Set the field to big-endian.
     */
    bigEndian() {
        return new FieldBuilder(this.type, { ...this.init, bigEndian: true });
    }
    toInit() {
        return { type: this.type, ...this.init };
    }
    /**
     * Override the typescript type of the field's value, for example to override `number` with an enum type.
     * This does not have any runtime effects.
     */
    $type() {
        return new FieldBuilder(this.type, this.init);
    }
}
export function array(type, length = 0) {
    return new FieldBuilder(new ArrayType(type, length), {});
}
